<template>
	<el-card>
		<div slot="header" class="questionnaire header">
			<img src="../image/progress.png" class="header-icon">
			<span class="header-title">Progress Reporting</span>
		</div>
		<ProgressTable :patient="patient" :questionnaire="completedQuestionnaires" :ascending="true"></ProgressTable>
	</el-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import OverviewCard from '..'
import ProgressTable from './Table'
import LoadingButton from '@/module/component/LoadingButton'

import QuestionnaireBucketMixin from '../mixin/questionnaire-bucket'

export default {
	name: 'patient-progress-card',
	extends: OverviewCard,

	mixins: [QuestionnaireBucketMixin],

	data() {
		return {
			printFeature: false,
			printed: false,
			upload: false,
			// If the upload is in progress
			uploading: false,
			sendId: null,
			sendNew: false,
			loading: false,
			loaded: false,
			sendMessage: 'Your doctor would like you to respond to the questionnaire so they are better prepared for your visit.',
			confirmDuplicate: false,
			selectedProviderQuestionnaire: []
		}
	},

	methods: {
		...mapActions('provider', [
			'createPatientMessage'
		]),
		sendQuestionnaire(id) {
			this.sendId = id
			this.confirmDuplicate = false
			this.sendNew = true
			this.loading = false
		},
		confirmSendQuestionnaire(id) {
			// Checking if questionaire has been previously sent
			if(!this.confirmDuplicate && this.isQuestionnaireRequested) {
				this.confirmDuplicate = true
				return
			}

			this.loading = true

			const messageData = {
				patient: this.patient.id,
				text: this.sendMessage,
				ref_type: 'questionnaire',
				ref_id: this.sendId
			}
			if(this.showMultiProviders && this.selectedProviderQuestionnaire.length > 0)
				messageData.provider = this.selectedProviderQuestionnaire[0].split(':')[0]
			else if (this.allPatientsChosen && this.patientProviderProfileList.length === 1)
				messageData.provider = this.patientProviderProfileList[0].provider
			else
				messageData.provider = null

			this.createPatientMessage(messageData)
			.then((result) => {
				console.log('result', result)
				this.loaded = true
				this.loading = false
				setTimeout(() => { this.sendNew = false }, 1200)
				setTimeout(() => { this.loaded = false }, 2000)
				// result.message[0].response - questionnaire event ID
				// this.patient.id

				// window.open(this.baseUrl + '/document/facesheet/?id=' +
				// Object.keys(this.select).filter((id) => this.select[id]).join(','))
			})
		},
		confirmPrintQuestionnaire() {
			this.sendNew = false

			const messageData = {
				patient: this.patient.id,
				text: this.sendMessage,
				ref_type: 'questionnaire',
				ref_id: this.sendId
			}

			if(this.showMultiProviders && this.selectedProviderQuestionnaire.length > 0)
				messageData.provider = this.selectedProviderQuestionnaire[0].split(':')[0]
			else if (this.allPatientsChosen && this.patientProviderProfileList.length === 1)
				messageData.provider = this.patient.patientProviderProfileList[0].provider
			else
				messageData.provider = null

			this.createPatientMessage(messageData)
			.then((result) => {
				console.log('result', result)
				// result.message[0].response - questionnaire event ID
				// this.patient.id

				// window.open(this.baseUrl + '/document/facesheet/?id=' +
				// Object.keys(this.select).filter((id) => this.select[id]).join(','))
			})
		},
		uploadQuestionnaires() {
			this.upload = true
		},
		cancelUpload() {
			this.upload = false
		},
		resetSendQuestionnaire() {
			this.confirmDuplicate = false
			this.sendNew = false
			this.loading = false
			this.sendMessage = 'Please answer this questionnaire.'
		},
		handleQuestionnaireChange(questionnaireValue) {
			if(questionnaireValue && Array.isArray(questionnaireValue) && questionnaireValue.length == 2)
				this.sendQuestionnaire(questionnaireValue[1])
		}
	},

	computed: {
		...mapGetters('provider', [
			'getPatientMessages',
			'getPatientSchedule',
			'getPatientMessagingState',
			'getProviderProfileList',
			'getProviderNameById',
			'allPatientsChosen',
			'getProvidersIdArray',
			'getPatientProviderProfileList'
		]),
		...mapGetters('content', [
			'getProfileContent',
		]),
		...mapGetters(['getUserType']),
		patientProviderProfileList() {
			return this.getPatientProviderProfileList(this.patient.id)
		},
		sending() {
			return this.getPatientMessagingState(this.patient.id)
		},
		profileQuestionnaires() {
			var questionnaires = []
			this.patientProviderProfileList.map(({ profile }) => {
				let p = this.getContent('profile', profile)
				if (p && p.questionnaire && this.getContent('questionnaire', p.questionnaire)) {
					questionnaires.push.apply(questionnaires, this.getContent('questionnaire', p.questionnaire))
				}
			})
			return questionnaires
		},
		questionnaire() {
			return this.patientEventType('questionnaire')
		},
		completedQuestionnaires() {
			return this.questionnaire.filter((q) => q.completed)
		},
		/**
		 * Checks if `this.sendId` questionnaire has been previously requestion and not answered
		 */
		isQuestionnaireRequested() {
			return this.questionnaire.find((question) => !question.completed && question.type.split(':')[1] === this.sendId) !== undefined
		},
		/**
		 * Calculates question buckets by event
		 * using patient schedules, messages and questionnaires
		 */
		questionnaireBucket() {
			return this.getQuestionnaireBuckets(this.getPatientSchedule(this.patient.id), this.getPatientMessages(this.patient.id), 
					this.questionnaire, 'response')
		},
		showMultiProviders() {
			return this.allPatientsChosen && (this.patientProviderProfileList.length > 1)
		},
		multiProviderQuestionnaireList() {
			try {
				return this.patient.profile_map
					.filter((providerProfile) => this.getProvidersIdArray.includes(providerProfile.split(':')[0]))
					.map((providerProfile) => {
						const [providerId, profileId ] = providerProfile.split(':')
						const value = providerProfile,
							label = `${this.getProviderNameById(providerId)} (${this.getContentKey('profile', profileId, 'title')})`
						const children = this.getProfileContent(profileId, 'questionnaire').map(({ id, title }) => ({ value: id, label: title }))
						return {
							value,
							label,
							children
						}
					})
			} catch (error) {
				console.error('Problem Calculating multiProviderQuestionnaireList ', error)
				return []
			}
		}
	},

	components: {
		ProgressTable,
		LoadingButton,
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.preview {
	margin-bottom: 5px;
	line-height: 24px;
	font-size: 16px;

	img {
		float: left;
		height: 24px;
		margin-right: 10px;
	}
}
.el-dialog .body {
	p {
		color: #7f7f7f;
		margin-bottom: 10px;
		word-break: normal;
	}
	.el-textarea {
		margin-bottom: 20px;
	}
}
.send-questionnaire-list {
	list-style: none;
	margin-block-start: 0;
	padding-inline-start: 0;
	margin-block-end: 0;
	max-height: 400px;
	overflow-y: scroll;
	li {
		cursor: pointer;
		padding: 10px;
	}
	li:hover {
		background-color: #f8f8f8;
	}
}
.el-card .header .send-link {
	float: right;
	padding: 0;
	margin-top: -4px;
	span {
		display: inline-block;
		font-size: 12px;
		padding: 0;
		font-weight: 500;
		background-color: #833e93;
		color: #ffffff;
		height: 26px;
		padding-left: 10px;
		padding-right: 10px;
		cursor: pointer;
	}
}
.bucket-header {
	background-color: $questionnaire-light;
	font-weight: 700;
	color: $black-color;
	font-size: 14px;
	height: 32px;
	line-height: 32px;
	margin-top: 14px;
	padding-left: 20px;
	display: flex;
	.bucket-date, .bucket-provider {
		padding-left: 12px;
		display: flex;
		align-items: center;
	}
	.bucket-provider {
		color: $grey-700;
		font-weight: normal;
	}
	.bucket-date::before, .bucket-provider::before {
		content: "\A";
		width: 3px;
		height: 3px;
		border-radius: 50%;
		background-color: $black-color;
		display: inline-block;
		margin-right: 12px;
	}
}
.sur-bckt {
	background-color: #EDF8DF;
}
.header-icon {
	height: 43px !important;
	margin-top: 0px !important;
}
</style>

<style lang="scss">
.el-popper.popper-send {
	box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2);
	padding: 0;
	&[x-placement^=bottom] {
		margin-top: 0;
		.popper__arrow {
			display: none;
		}
	}
}

.bucket-body {
	// Make last border before element color transparent
	.el-table::before {
		background-color: transparent;
	}
	// Remove last border for questionnaire
	.el-table tbody tr:last-child td {
		border-bottom: none;
	}
}
.el-cascader.questionnaire-cascader {
	position: absolute;
	right: 0;
	width: 100px;
	opacity: 0;
	height: 40px;
	line-height: 40px;
	.el-input__inner {
		height: 40px;
	}
}
</style>
